<ng-container *ngIf="ctx" [ngSwitch]="mainService.getShopPortalLayoutKind()">  
  <app-item-info-boxed-layout [ctx]="ctx" *ngSwitchDefault></app-item-info-boxed-layout>
  <app-item-info-scroll-layout [ctx]="ctx" *ngSwitchCase="1"></app-item-info-scroll-layout>
</ng-container>
